import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/lib/orpc/client';
import { toBorrowDialogData, toLendWithdrawDialogData } from './marketDialog.mapper';
interface MarketDialogInput {
  chainId: number;
  marketId: MarketId;
}

/** The borrow-more dialog's market, borrow APY and rewards, from `market.borrowDialog`. */
export function useBorrowDialogData(t0) {
  const $ = _c(10);
  const {
    chainId,
    marketId
  } = t0;
  let t1;
  if ($[0] !== chainId || $[1] !== marketId) {
    t1 = orpc.market.borrowDialog.queryOptions({
      input: {
        chainId,
        marketId
      }
    });
    $[0] = chainId;
    $[1] = marketId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    isPending,
    error
  } = useQuery(t1);
  let t2;
  if ($[3] !== chainId || $[4] !== data) {
    t2 = data && toBorrowDialogData(chainId, data);
    $[3] = chainId;
    $[4] = data;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = data ? null : error;
  let t4;
  if ($[6] !== isPending || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      data: t2,
      isPending,
      error: t3
    };
    $[6] = isPending;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/**
 * The lend and lend-withdraw dialogs' market, supply APY and rewards, from
 * `market.lendWithdrawDialog`. Both dialogs share the query, so the second to open reads it warm.
 */
export function useLendWithdrawDialogData(t0) {
  const $ = _c(10);
  const {
    chainId,
    marketId
  } = t0;
  let t1;
  if ($[0] !== chainId || $[1] !== marketId) {
    t1 = orpc.market.lendWithdrawDialog.queryOptions({
      input: {
        chainId,
        marketId
      }
    });
    $[0] = chainId;
    $[1] = marketId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    isPending,
    error
  } = useQuery(t1);
  let t2;
  if ($[3] !== chainId || $[4] !== data) {
    t2 = data && toLendWithdrawDialogData(chainId, data);
    $[3] = chainId;
    $[4] = data;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = data ? null : error;
  let t4;
  if ($[6] !== isPending || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      data: t2,
      isPending,
      error: t3
    };
    $[6] = isPending;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}